import { CollapsibleWidget, Table } from 'components/patterns'
import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { List } from 'antd'

export const StyledTable = styled(Table)`
  & .ant-table-tbody > tr > td {
    vertical-align: baseline;
  }
  & .ant-table-tbody > tr.dynamic-feature-row > td {
    vertical-align: top !important;
    padding-top: 6px !important;
  }
  &.features-table-fixed-layout table {
    table-layout: fixed;
  }
  &.features-table-fixed-layout colgroup col.custom-column {
    width: 70px !important;
  }
  &.features-table-fixed-layout colgroup col.description-column {
    width: auto !important;
    min-width: 100px !important;
  }
`

export const InfoIcon = styled.img`
  width: 15px;
  height: 15px;
`

export const SupLimitExceeded = styled.sup((props) => {
  const { isLimitExceeded } = props
  if (isLimitExceeded) {
    return `
  background-color: ${themeColor('errorPrimary', props)};
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 10px;
  color: ${themeColor('whitePrimary', props)};
`
  }
  return `
  font-size: 10px;
  `
})

export const StyledCollapsibleWidget = styled(CollapsibleWidget)`
  &&&.dynamic-feat-collapse {
    pointer-events: none;
    & .dynamic-feat-collapse-panel {
      border: 0;

      & .ant-collapse-header {
        margin: 0;
        padding: 0 !important;
        color: ${themeColor('blackSecondary')};
      }
      & .ant-collapse-content-box {
        padding: 0;
      }
    }
  }
`

export const StyledList = styled(List)`
  padding: 0;
  margin-top: 8px;
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
`

export const StyledListItem = styled(List.Item)`
  padding: 8px 0 !important;
  &:last-child {
    padding-bottom: 0 !important;
  }
`
